import React from 'react';
import ModalShell from './ModalShell';

const ActionFormModal = ({
  isOpen,
  title,
  onClose,
  onSubmit,
  submitText = 'Confirmer',
  cancelText = 'Annuler',
  isSubmitting = false,
  submitDisabled = false,
  maxWidthClass = 'max-w-lg',
  children,
}) => {
  if (!isOpen) return null;

  return (
    <ModalShell
      maxWidthClass={maxWidthClass}
      zClass="z-50"
      panelClassName="flex min-h-0 flex-col overflow-hidden p-0"
      onBackdropClick={() => !isSubmitting && onClose?.()}
    >
      <div className="mm-modal-header">
        <div className="min-w-0">
          <h3 className="font-display text-lg font-extrabold tracking-tight text-[#0f3350]">
            {title}
          </h3>
        </div>
        <button
          type="button"
          onClick={() => !isSubmitting && onClose?.()}
          className="mm-press flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-100/80 text-slate-500"
          aria-label={cancelText}
          disabled={isSubmitting}
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <form onSubmit={onSubmit} className="flex min-h-0 flex-1 flex-col">
        <div className="min-h-0 flex-1 space-y-3 overflow-y-auto px-4 py-3 sm:px-5 sm:py-4">
          {children}
        </div>

        <div className="mm-modal-footer">
          <button
            type="button"
            onClick={onClose}
            className="mm-cta mm-cta--ghost flex-1"
            disabled={isSubmitting}
          >
            {cancelText}
          </button>
          <button
            type="submit"
            className="mm-cta flex-1 disabled:opacity-50"
            disabled={isSubmitting || submitDisabled}
          >
            {submitText}
          </button>
        </div>
      </form>
    </ModalShell>
  );
};

export default ActionFormModal;
